import React, { Component } from "react";

import { CCollapse, CLink } from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select from "react-select";
import {
  Row,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  Label
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class LoList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: [],
      // user: {},
      // updated: false,
      // searched: false,
      loading: true,
      content: null,
      name: "Carregando...",
      filter: {
        word: null,
        segment: { value: null, label: "Todos" },
        discipline: { value: null, label: "Todos" },
        serie: { value: null, label: "Todas" },
        module: { value: null, label: "Todos" },
        ability: { value: null, label: "Todos" },
        flash: { value: null, label: "Todos" },
        status: { value: null, label: "Todos" }
      },
      filterCollapse: false,
      ability_filter: true,
      filters: {},
      segments: [],
      flashOptions: [
        { value: null, label: "Todos" },
        { value: "converted", label: "HTML5" },
        { value: "flash", label: "Flash" }
      ],
      statusOptions: [
        { value: "%%", label: "Todos" },
        { value: "Em produção", label: "Em produção" },
        { value: "Homologado", label: "Homologado" },
        { value: "Liberado", label: "Liberado" }
      ],
      loadingContent: true,

      currPage: 1,
      totalPages: 1
    };

    this.error = this.error.bind(this);
    this.insertLo = this.insertLo.bind(this);
    this.changePage = this.changePage.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  changePage(page) {
    this.setState({ currPage: page }, () => this.filter(this.state.filters));
  }

  insertLo() {
    const { content } = this.props.match.params;
    this.props.history.push(`/lo/form?type=${content}`);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
  }

  filter(filters) {
    this.setState({ filters, loadingContent: true }, () => {
      const { content } = this.props.match.params;

      const filters = {
        type: content,
        word: this.state.filters.word,
        segment: this.state.filters.segment && this.state.filters.segment.value,
        discipline:
          this.state.filters.discipline && this.state.filters.discipline.value,
        serie: this.state.filters.serie && this.state.filters.serie.value,
        module:
          !this.state.ability_filter &&
          this.state.filters.module &&
          this.state.filters.module.value,
        ability:
          this.state.ability_filter &&
          this.state.filters.ability &&
          this.state.filters.ability.value,
        status: this.state.filters?.status?.value || "%%",
        converted:
          this.state.filters.flash &&
          this.state.filters.flash.value === "converted"
            ? ["SIM", "VALBERTO"]
            : this.state.filters.flash.value === "flash"
            ? ["NAO", "HIBRIDO"]
            : null,
        source: 1
      };

      axios
        .post(`${URL.api}content/los/listLosFilter`, filters, {
          headers: { Authorization: `Bearer ${this.props.user.token}` },
          params: { page: this.state.currPage, page_size: 10 }
        })
        .then(
          resp => {
            this.setState(
              {
                list:
                  resp.data.data.length > 0 ? resp.data.data[0].content : [],
                loadingContent: false,
                loading: false,
                name: resp.data.data.length > 0 ? resp.data.data[0].name : "",
                totalPages: resp.data.meta.last_page,
                currPage: resp.data.meta.current_page
              },
              () => {
                if (this.state.name === "") {
                  axios
                    .get(`${URL.api}content/los/typeName/${content}`, {
                      headers: {
                        Authorization: `Bearer ${this.props.user.token}`
                      }
                    })
                    .then(resp => {
                      this.setState({ name: resp.data.data.name });
                    });
                }
              }
            );
          },
          error => {
            this.error("Não foi possível carregar os LOs");
          }
        );
    });
  }

  initContent() {
    this.setState({ loading: true });
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const { content } = this.props.match.params;
    const losCachedFilters = localStorage.getItem(
      `losFilter@${this.props.currentRoute}`
    );

    axios
      .get(
        `${URL.api}content/los/filterStructureObjective/${this.props.match.params.content}`,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(resp => {
        const segment =
          resp.data.data.length > 0
            ? resp.data.data[0]
            : { id: null, name: "Todos", series: [] };
        const serie =
          segment.series.length > 0
            ? segment.series[0]
            : { id: null, name: "Todos", disciplines: [] };
        const discipline =
          serie.disciplines.length > 0
            ? serie.disciplines[0]
            : { id: null, name: "Todas", objectives: [] };
        const objective =
          discipline.objectives.length > 0
            ? discipline.objectives[0]
            : { id: null, name: "Todos", modules: [], abilities: [] };
        const module =
          objective.modules.length > 0
            ? objective.modules[0]
            : { id: null, name: "Todos" };
        const ability =
          objective.abilities.length > 0
            ? objective.abilities[0]
            : { id: null, name: "Todos" };

        const filter = losCachedFilters
          ? JSON.parse(losCachedFilters)
          : resp.data.data.length
          ? {
              word: null,
              segment: { value: segment.id, label: segment.name },
              discipline: { value: discipline.id, label: discipline.name },
              serie: { value: serie.id, label: serie.name },
              module: { value: module.id, label: module.name },
              ability: { value: ability.id, label: ability.name },
              flash: { value: null, label: "Todos" },
              status: { value: "%%", label: "Todos" }
            }
          : // eslint-disable-next-line react/no-access-state-in-setstate
            this.state.filter;

        this.setState(
          { segments: resp.data.data, filter, filters: filter },
          () => {
            this.filter(this.state.filters);
          }
        );
      });

    if (content) {
      this.setState({ content });
    }
  }

  deleteRow = deletedRows => {
    deletedRows.forEach(elem => {
      axios
        .post(
          `${URL.api}content/los/delete/${elem}`,
          {},
          { headers: { Authorization: `Bearer ${this.props.user.token}` } }
        )
        .then(resp => {
          // eslint-disable-next-line react/no-access-state-in-setstate
          const filtered = this.state.list.filter(item => item.id !== elem);
          this.setState({ list: filtered });
        });
    });
    this.forceUpdate();
  };

  changeFilter(prop, value) {
    this.setState(
      state => {
        let filter = { ...state.filter };
        filter[prop] = value;

        if (prop === "segment") {
          filter.serie = { value: null, label: "Todas" };
          filter.discipline = { value: null, label: "Todos" };
          filter.module = { value: null, label: "Todos" };
          filter.ability = { value: null, label: "Todos" };
        } else if (prop === "serie") {
          filter.discipline = { value: null, label: "Todos" };
          filter.module = { value: null, label: "Todos" };
          filter.ability = { value: null, label: "Todos" };
        } else if (prop === "discipline") {
          filter.module = { value: null, label: "Todos" };
          filter.ability = { value: null, label: "Todos" };
        }

        localStorage.setItem(
          `losFilter@${this.props.currentRoute}`,
          JSON.stringify(filter)
        );

        return { filter, filters: filter };
      },
      () => {
        if (prop !== "word") {
          this.filter(this.state.filter);
        }
      }
    );
  }

  getFilterComponent() {
    let segments = this.state.segments
      .sort((a, b) => a.order - b.order)
      .map(segment => ({
        value: segment.id,
        label: segment.name,
        series: segment.series
      }));
    let series = [];
    let disciplines = [];
    let modules = [];
    let abilities = [];

    if (this.state.filter.segment?.value) {
      series = segments
        .filter(segment => segment.value === this.state.filter.segment.value)
        .reduce((acc, val) => [...acc, ...val.series], [])
        .sort((a, b) => a.order - b.order)
        .map(serie => ({
          value: serie.id,
          label: serie.name,
          disciplines: serie.disciplines
        }));
    } else {
      series = segments
        .reduce(
          (acc, val) => [
            ...acc,
            ...val.series.map(item => ({ ...item, segment_id: val.value }))
          ],
          []
        )
        .sort(
          (a, b) =>
            a.segment_id * 100 + a.order - (b.segment_id * 100 + b.order)
        )
        .map(serie => ({
          value: serie.id,
          label: serie.name,
          disciplines: serie.disciplines
        }));
    }

    if (this.state.filter.serie?.value) {
      disciplines = series
        .filter(serie => serie.value === this.state.filter.serie.value)
        .reduce((acc, val) => [...acc, ...val.disciplines], [])
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(discipline => ({
          value: discipline.id,
          label: discipline.name,
          modules: discipline.objectives,
          abilities: discipline.objectives
        }));
    } else {
      disciplines = series
        .reduce((acc, val) => [...acc, ...val.disciplines], [])
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(discipline => ({
          value: discipline.id,
          label: discipline.name,
          modules: discipline.objectives,
          abilities: discipline.objectives
        }));
    }

    if (this.state.filter.discipline?.value) {
      modules = disciplines
        .filter(
          discipline => discipline.value === this.state.filter.discipline.value
        )
        .reduce((acc, val) => [...acc, ...val.modules], [])
        .map(objective => ({
          label: objective.description,
          id: objective.id,
          options: objective.modules
            .filter(module => module.id)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(module => ({ value: module.id, label: module.name }))
        }));

      abilities = disciplines
        .filter(
          discipline => discipline.value === this.state.filter.discipline.value
        )
        .reduce((acc, val) => [...acc, ...val.abilities], [])
        .map(objective => ({
          label: objective.description,
          id: objective.id,
          options: objective.abilities
            .filter(ability => ability.id)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(ability => ({ value: ability.id, label: ability.name }))
        }));
    } else {
      modules = disciplines
        .reduce((acc, val) => [...acc, ...val.modules], [])
        .map(objective => ({
          label: objective.description,
          id: objective.id,
          options: objective.modules
            .filter(module => module.id)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(module => ({ value: module.id, label: module.name }))
        }));

      abilities = disciplines
        .reduce((acc, val) => [...acc, ...val.abilities], [])
        .map(objective => ({
          label: objective.description,
          id: objective.id,
          options: objective.abilities
            .filter(ability => ability.id)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(ability => ({ value: ability.id, label: ability.name }))
        }));
    }

    segments = [
      { value: null, label: "Todos" },
      ...segments.filter(
        (segment, index) =>
          segments.findIndex(item => item.value === segment.value) === index
      )
    ];
    series = [
      { value: null, label: "Todas" },
      ...series.filter(
        (serie, index) =>
          series.findIndex(item => item.value === serie.value) === index
      )
    ];
    disciplines = [
      { value: null, label: "Todos" },
      ...disciplines.filter(
        (discipline, index) =>
          disciplines.findIndex(item => item.value === discipline.value) ===
          index
      )
    ];
    modules = [
      { value: null, label: "Todos" },
      ...modules.filter(
        (module, index) =>
          modules.findIndex(item => item.id === module.id) === index &&
          module.options.length > 0
      )
    ];
    abilities = [
      { value: null, label: "Todos" },
      ...abilities.filter(
        (ability, index) =>
          abilities.findIndex(item => item.id === ability.id) === index &&
          ability.options.length > 0
      )
    ];

    return (
      <CCollapse
        show={this.state.filterCollapse}
        className="d-lg-block card-overflow"
      >
        <div className="p-3" style={{ borderBottom: "1px solid #d8dbe0" }}>
          <div className="d-flex flex-column flex-md-row card-overflow m-0">
            <div className="flex-1 d-block d-md-none">
              <Label>Pesquisar</Label>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fa fa-text-width"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Pesquisar"
                  onChange={e => this.changeFilter("word", e.target.value)}
                  value={this.state.filter.word}
                  type="text"
                  style={{
                    borderRight: 0,
                    outline: 0,
                    borderColor: "#d8dbe0",
                    boxShadow: "none",
                    flex: 1
                  }}
                />
                <InputGroupAddon addonType="append">
                  <InputGroupText className="bg-white pl-0">
                    <i
                      className="fa fa-search text-muted content-search-icon"
                      onClick={() => this.filter(this.state.filter)}
                    ></i>
                  </InputGroupText>
                </InputGroupAddon>
              </InputGroup>
              <div className="p-2"></div>
            </div>
            <div className="flex-1">
              <div className="w-100 text-ellipsis">
                <Label className="d-block w-100 text-ellipsis">Segmento</Label>
              </div>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fa fa-text-width"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Select
                  placeholder="Segmento"
                  onChange={e => this.changeFilter("segment", e)}
                  value={this.state.filter.segment}
                  options={segments}
                  type="text"
                  className="flex-1"
                />
              </InputGroup>
            </div>
            <div className="p-2"></div>
            <div className="flex-1">
              <div className="w-100 text-ellipsis">
                <Label className="d-block w-100 text-ellipsis">Série</Label>
              </div>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fa fa-text-width"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Select
                  placeholder="Série"
                  onChange={e => this.changeFilter("serie", e)}
                  value={this.state.filter.serie}
                  options={series}
                  type="text"
                  className="flex-1"
                />
              </InputGroup>
            </div>
            <div className="p-2"></div>
            <div className="flex-1">
              <div className="w-100 text-ellipsis">
                <Label className="d-block w-100 text-ellipsis">
                  Componente curricular
                </Label>
              </div>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fa fa-text-width"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Select
                  placeholder="Componente curricular"
                  onChange={e => this.changeFilter("discipline", e)}
                  value={this.state.filter.discipline}
                  options={disciplines}
                  type="text"
                  className="flex-1"
                />
              </InputGroup>
            </div>
            <div className="p-2"></div>
            <div className="flex-1">
              <div className="w-100 text-ellipsis">
                <Label className="d-block w-100 text-ellipsis">
                  {this.state.ability_filter ? "Habilidade" : "Módulo"}
                  <CLink
                    className="ml-2"
                    onClick={() =>
                      this.setState(
                        state => ({
                          ability_filter: !state.ability_filter
                        }),
                        () =>
                          this.changeFilter(
                            this.state.ability_filter ? "ability" : "module",
                            { value: null, label: "Todos" }
                          )
                      )
                    }
                  >
                    (
                    {this.state.ability_filter
                      ? "Eixo temático BNCC"
                      : "Habilidades BNCC"}
                    )
                  </CLink>
                </Label>
              </div>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fa fa-text-width"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Select
                  placeholder={
                    this.state.ability_filter
                      ? "Habilidades BNCC"
                      : "Eixo temático BNCC"
                  }
                  key={this.state.ability_filter}
                  onChange={e =>
                    this.changeFilter(
                      this.state.ability_filter ? "ability" : "module",
                      e
                    )
                  }
                  value={
                    this.state.ability_filter
                      ? this.state.filter.ability
                      : this.state.filter.module
                  }
                  options={this.state.ability_filter ? abilities : modules}
                  type="text"
                  className="flex-1"
                />
              </InputGroup>
            </div>
            <div className="p-2"></div>
            <div className="flex-1">
              <div className="w-100 text-ellipsis">
                <Label className="d-block w-100 text-ellipsis">Tipo</Label>
              </div>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fa fa-text-width"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Select
                  placeholder="Tipo"
                  onChange={e => this.changeFilter("flash", e)}
                  value={this.state.filter.flash}
                  options={this.state.flashOptions}
                  type="text"
                  className="flex-1"
                />
              </InputGroup>
            </div>
            <div className="p-2"></div>
            <div className="flex-1">
              <div className="w-100 text-ellipsis">
                <Label className="d-block w-100 text-ellipsis">Status</Label>
              </div>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fa fa-text-width"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Select
                  placeholder="Tipo"
                  onChange={e => this.changeFilter("status", e)}
                  value={this.state.filter.status}
                  options={this.state.statusOptions}
                  type="text"
                  className="flex-1"
                />
              </InputGroup>
            </div>
          </div>
        </div>
      </CCollapse>
    );
  }

  render() {
    if (this.state.content !== this.props.match.params.content)
      this.initContent();

    return (
      <div className="animated fadeIn">
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Row>
            <Breadcrumb current={this.props.currentRoute} />
            {this.state.list ? (
              <div id="list">
                <DataTable
                  filterComponent={this.getFilterComponent()}
                  list={this.state.loadingContent ? [] : this.state.list}
                  path="/lo/edit/"
                  viewPath="/content/view/"
                  viewBlank
                  viewQuery={r => `?title=${r.name}`}
                  title={this.state.name}
                  header={[
                    { name: "id", denomination: "ID" },
                    { name: "name", denomination: "Nome" },
                    {
                      name: "series",
                      denomination: "Séries",
                      dataFormat: (cell, row) =>
                        cell.map(serie => serie.name).join(", ") || "-"
                    },
                    { name: "discipline_name", denomination: "Disciplina" },
                    { name: "module_description", denomination: "Módulo" },
                    {
                      name: "ability_description",
                      denomination: "Habilidade"
                    },
                    { name: "external_id", denomination: "Código Externo" }
                  ]}
                  insert
                  delete
                  action
                  btnEdit
                  btnView
                  insertAction={this.insertLo}
                  deleteAction={this.deleteRow}
                  noDataIndication={
                    this.state.loadingContent && "Carregando..."
                  }
                  currPage={this.state.currPage}
                  totalPages={this.state.totalPages}
                  changePage={this.changePage}
                />
              </div>
            ) : (
              <Loading />
            )}
          </Row>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LoList);
